module.exports = {
  name: 'cert',
  ampContent: 'https://cert.hmhco.com/content',
  ampLoggedInURL: 'https://cert.hmhco.com/ui/logged-in/',
  ampLogin: 'https://cert.hmhco.com/ui/login/',
  ampLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  ampLoginPrivacyPolicy:
    'https://www.hmhco.com/prek-12-products-privacy-policy',
  ampLoginTermsAndConditions:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  apiEngHostname: 'https://api.cert.hmhco.com',
  apiEngHostnamePublic: 'https://api.cert.hmhco.com',
  assessments: 'https://cert.hmhco.com/api/assessment',
  assignments: 'https://cert.hmhco.com/api/assignment',
  authorizationApi: 'https://cert.hmhco.com/api/authorization',
  auth0: 'https://hmhco-eng.auth0.com',
  auth0CreateConnectionsHost:
    'https://api.cert.hmhco.com/auth-self-service-setup/api/v1/sso',
  auth0FetchConnectionsHost:
    'https://api.cert.hmhco.com/auth-self-service-setup/api/v1/sso/datastore/connection',
  baseURL: 'https://cert.hmhco.com',
  classes: 'https://cert.hmhco.com/ui/classes',
  classesClasses: 'https://cert.hmhco.com/ui/classes/classes',
  clientRegistry: 'https://api.cert.hmhco.com/idm-client-registry',
  contentPicker: 'https://cert.hmhco.com/one/picker/',
  contentPickerAMP: 'http://cert.hmhco.com/ui/#/picker',
  contentProvider: 'http://cert.hmhco.com/ui/#/contentProvider/',
  ctsDistrictLogin: 'https://cert.hmhco.com/ui/login/?connection=',
  districtDownloadApi:
    'https://api.cert.hmhco.com/data-district-download-service',
  ebrCore: 'https://api.cert.hmhco.com/idm-ebr-core',
  ebrUi: 'https://cert.hmhco.com/import/',
  edContent: 'https://cert.hmhco.com/content',
  edDistrictLogin: 'https://cert.hmhco.com/one/login/?connection=',
  edHostname: 'https://cert.hmhco.com/',
  edLoggedInURL: 'https://cert.hmhco.com/one/logged-in',
  edLogin: 'https://cert.hmhco.com/ui/login/',
  edRoot: 'https://cert.hmhco.com/one/#/',
  EDSLoginUrl: 'https://hapi.cert.hmhco.com/edcore/eds-login',
  EDSResourceUrl: 'https://api.cert.heinemann.com',
  forgotPassword: 'https://cert.hmhco.com/ui/login/forgot-password/',
  grading: 'https://cert.hmhco.com/api/grading/',
  hmhHelpCenter: 'http://downloads.hmlt.hmco.com',
  hmoHostname: 'https://my-cert.hrw.com/sp/',
  hmoLoginPath: 'https://my-cert.hrw.com/index.jsp',
  idm: 'https://cert.idm.api.hmhco.com/openid-connect',
  jasperReporting: 'https://cert.hmhco.com/jasperserver-pro',
  licensing: 'http://cert.hmhco.com/ui/#/licenses',
  liftRoot: 'https://cert.hmhco.com/ui/',
  loginPath: '/ui/login/',
  myClasses: 'https://cert.hmhco.com/ui/!my-classes',
  myStuff: 'http://cert.hmhco.com/ui/#/my-stuff/lessons',
  notificationsApi: 'https://api.cert.hmhco.com',
  oktaConnectionApi:
    'https://api.cert.hmhco.com/okta-services-gateway/api/v1/sso',
  oktaFetchConnectionsHost:
    'https://api.cert.hmhco.com/okta-services-gateway/api/v1/sso/idps',
  oktaNewOrg: 'https://api.cert.hmhco.com/okta-services-gateway/api/v1/org',
  onesearch: 'https://cert.hmhco.com/api/onesearch/v1',
  picker: 'https://cert.hmhco.com/ui/#/picker/',
  plannerHost: 'https://api.cert.hmhco.com/planner-api',
  plannerHostNonWaf: 'https://api.cert.eng.hmhco.com/planner-api',
  plsAuthors: 'https://api.cert.hmhco.com/pls-services-author/api/v5/authors',
  plsLessonRelatedResource:
    'https://api.cert.hmhco.com/pls-services-lessonrelatedresource/api/v5/lessonrelatedresources',
  plsRelatedResources:
    'https://api.cert.hmhco.com/pls-services-relatedresource/api/v5/relatedresources',
  plsResource:
    'https://api.cert.hmhco.com/pls-services-resource/api/v5/resources',
  edsApiGateway: 'https://hapi.cert.hmhco.com/edcore/hmheng-eds-api-gateway/',
  prefixCDS: 'https://cds-metadatapipeline.cert.br.hmheng.io',
  productLanding: 'http://cert.hmhco.com/ui/#/product',
  restApi: 'https://api.cert.hmhco.com',
  restHapi: 'https://hapi.cert.hmhco.com',
  restDMPS: 'https://api.cert.hmhco.com/dmps',
  restDMPSNonWAF: 'https://api.cert.eng.hmhco.com/dmps',
  restELM: 'https://api.cert.eng.hmhco.com/elm/v1',
  restIdsApi: 'https://api.cert.br.internal/ids', // for purging users in IDS we need a different API
  restIdsGridApi: 'https://api.cert.hmhco.com/ids-grid-api',
  restIdsGridApiNonWAF: 'https://api.cert.eng.hmhco.com/ids-grid-api',
  restNotifications: 'https://api.cert.hmhco.com/notifications',
  restNotificationsNonWAF: 'https://api.cert.eng.hmhco.com/notifications',
  restOAC: 'https://api.cert.hmhco.com/oac/v3',
  restOACNonWAF: 'https://api.cert.eng.hmhco.com/oac/v3',
  restPostPrefix: 'https://cert.hmhco.com',
  restPrefix: 'https://cert.hmhco.com',
  restRecommendation: 'https://api.cert.eng.hmhco.com/recommendation-api',
  restStagingProcessor: 'https://api.cert.hmhco.com/idm-staging-processor',
  restSusApi: 'https://api.cert.br.internal/idm-user-api', // for purging users in SUS
  restUdsApi: 'https://api.cert.hmhco.com/uds',
  restUpdatesApi: 'https://api.cert.hmhco.com/update-catalog',
  rosterDashboard: 'https://cert.hmhco.com/ui/#/roster',
  r180Api: 'https://cert.hmhco.com/api/r180/',
  r180Media: 'https://cert.hmhco.com/r180/media',
  sisHostname: 'https://cert.hmhco.com/',
  sso: 'https://api.cert.hmhco.com/auth-self-service-setup',
  storyBook: 'https://cert.hmhco.com/ui/storybook/',
  susAuth: 'https://cert.hmhco.com/api/authorization',
  tcHostname: 'https://www-cert.thinkcentral.com/sp/',
  tcLoginPath: 'https://www-cert.thinkcentral.com/ePC/start.do',
  teacherDashboard: 'https://cert.hmhco.com/ui/',
  linkedAssignments:
    'https://cert.hmhco.com/ui/#/assign-full?resourceId=l_ff9bdd36-f627-4241-8dbc-9f9b4f158f56_c7b06f27-597b-42fc-8169-67247568e97f&programId=IM_NL20_G4&title=Unit+Opener%3A+Place+Value+and+Whole+Number+Operations&backTo=discover%252FIM_NL20_G4%252F1&showSched=true&recBy=NONE&isSgm=false',
  virtualClassroom: 'https://cert.hmhco.com/ui/#/virtual-classroom',
  virtualClassroomApi:
    'https://api.cert.hmhco.com/vcservice/virtual-classroom/meeting',
  wormhole: 'https://api.cert.hmhco.com/wh-api/graphql',
  importingService: 'https://api.cert.hmhco.com/idm-api-importing-service',
};
